import { createFileRoute } from '@tanstack/react-router';
import { RelationshipsQueryTab } from '@/pages/workspaces/journeys/integrations/sql-sync/import/tabs/relationships-query-tab';

/** The Relationship Query tab: edit and re-run the query relating the imported rows. */
export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/relationships-query',
)({
  component: RelationshipsQueryTab,
});
